import { DiContainerInjectFn } from '@/di/ts';
import { ModalService } from './services/modal.service';

export default ((container) => {
  container.bind(ModalService).to(ModalService).inSingletonScope();
}) as DiContainerInjectFn;
